import * as React from 'react';
const SvgLike = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 18 18" fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.9 2.5C11.9 1 10.418 0 9.26 0c-.806 0-.869.612-.993 1.82-.055.53-.121 1.174-.267 1.93-.386 2.002-1.72 4.56-2.996 5.325V15C5 17.25 5.75 18 9 18h3.773c2.176 0 2.703-1.433 2.899-1.964l.013-.036c.114-.306.358-.547.638-.82.31-.306.664-.653.927-1.18.311-.623.27-1.177.233-1.67-.023-.299-.044-.575.017-.83.064-.27.146-.475.225-.671.143-.356.275-.686.275-1.329 0-1.5-.748-2.498-2.315-2.498H11.5S11.9 4 11.9 2.5zM1.5 8A1.5 1.5 0 000 9.5v7a1.5 1.5 0 003 0v-7A1.5 1.5 0 001.5 8z"
            fill="currentColor"
        />
    </svg>
);
export default SvgLike;
